import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    integration: {
      connect: 'Connecter',
    },
    integrations: {
      seeAll: 'Voir toutes les intégrations',
      similar: 'Intégrations similaires',
    },
  },
  fr: {
    integration: {
      connect: 'Connecter',
    },
    integrations: {
      seeAll: 'Voir toutes les intégrations',
      similar: 'Intégrations similaires',
    },
  },
});

export default locales;
